/**
 * @file 加入哈兔
 * @author 丁聪
 */

import React, { Component } from 'react'
import { Banner, People, Synopsis, Ask, Email } from './components/index'
import { Footer } from '../../components/basic/index'

// import './index.scss'

class Join extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() { }

  render() {
    return (
      <div>
        <Banner />
        <People />
        <Synopsis />

        <Ask />
        <Email />
        <Footer />
      </div>
    )
  }
}

export default Join
